import { useRef } from "react";

export const useAbortController = () => {
  const controllerRef = useRef<AbortController>(new AbortController());

  const handleAbortController = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;

    return newController;
  };

  return { handleAbortController };
};
